export const practiceResources = [
  {
    id: 1,
    type: 'Video Course',
    title: 'Ethical Hacking Bootcamp',
    description: '42 hours of structured video content covering penetration testing from scratch to advanced.',
    icon: 'ri-video-line',
    color: 'from-[#00D9FF] to-[#0066CC]',
    count: '42 hrs',
    level: 'All Levels',
    image: 'https://public.readdy.ai/ai/img_res/09e342012c9c9d5507c960789f549f6e.jpg',
  },
  {
    id: 2,
    type: 'Documentation',
    title: 'OWASP Top 10 Guide',
    description: 'Comprehensive documentation on the most critical web application security risks with examples.',
    icon: 'ri-file-text-line',
    color: 'from-[#00C896] to-[#007A5E]',
    count: '120 pages',
    level: 'Intermediate',
    image: 'https://readdy.ai/api/search-image?query=abstract%20documentation%20and%20technical%20writing%20visualization%20with%20glowing%20text%20on%20dark%20background%2C%20cybersecurity%20themed%2C%20green%20and%20teal%20highlights%2C%20no%20people&width=400&height=240&seq=res-img-002&orientation=landscape',
  },
  {
    id: 3,
    type: 'Cheat Sheet',
    title: 'Linux Commands for Pentesters',
    description: 'Quick-reference cheat sheet with the most essential Linux commands for penetration testing.',
    icon: 'ri-file-list-3-line',
    color: 'from-[#F59E0B] to-[#B45309]',
    count: '8 pages',
    level: 'Beginner',
    image: 'https://readdy.ai/api/search-image?query=glowing%20terminal%20command%20cheat%20sheet%20on%20dark%20background%20with%20Linux%20commands%2C%20amber%20and%20gold%20highlights%2C%20cybersecurity%20aesthetic%2C%20no%20people%2C%20abstract&width=400&height=240&seq=res-img-003&orientation=landscape',
  },
  {
    id: 4,
    type: 'CTF Challenges',
    title: 'Weekly CTF Competition',
    description: 'Compete in weekly Capture The Flag challenges across web, crypto, forensics, and reverse engineering.',
    icon: 'ri-trophy-line',
    color: 'from-[#EC4899] to-[#9D174D]',
    count: '200+ flags',
    level: 'All Levels',
    image: 'https://readdy.ai/api/search-image?query=abstract%20CTF%20capture%20the%20flag%20competition%20visualization%20with%20glowing%20trophy%20and%20digital%20flags%20on%20dark%20background%2C%20pink%20and%20magenta%20highlights%2C%20cybersecurity%20gaming%20aesthetic%2C%20no%20people&width=400&height=240&seq=res-img-004&orientation=landscape',
  },
  {
    id: 5,
    type: 'Practice Path',
    title: 'Bug Bounty Hunter Path',
    description: 'Structured learning path to become a professional bug bounty hunter with real-world targets.',
    icon: 'ri-bug-line',
    color: 'from-[#A855F7] to-[#6B21A8]',
    count: '18 modules',
    level: 'Intermediate',
    image: 'https://readdy.ai/api/search-image?query=abstract%20bug%20bounty%20hunting%20visualization%20with%20glowing%20magnifying%20glass%20and%20code%20vulnerabilities%20on%20dark%20background%2C%20purple%20and%20violet%20highlights%2C%20cybersecurity%20themed%2C%20no%20people&width=400&height=240&seq=res-img-005&orientation=landscape',
  },
  {
    id: 6,
    type: 'Tooling Guide',
    title: 'Kali Linux Toolkit',
    description: 'Master the most powerful security tools in Kali Linux with step-by-step usage guides.',
    icon: 'ri-tools-line',
    color: 'from-[#FF6B35] to-[#CC4400]',
    count: '60+ tools',
    level: 'Advanced',
    image: 'https://readdy.ai/api/search-image?query=abstract%20Kali%20Linux%20security%20tools%20visualization%20with%20glowing%20wrench%20and%20terminal%20icons%20on%20dark%20background%2C%20orange%20and%20red%20highlights%2C%20cybersecurity%20hacking%20aesthetic%2C%20no%20people&width=400&height=240&seq=res-img-006&orientation=landscape',
  },
  {
    id: 7,
    type: 'Podcast',
    title: 'Security Weekly Podcast',
    description: 'Weekly episodes featuring interviews with top security researchers and industry news breakdowns.',
    icon: 'ri-mic-line',
    color: 'from-[#06B6D4] to-[#0E7490]',
    count: '180+ episodes',
    level: 'All Levels',
    image: 'https://readdy.ai/api/search-image?query=abstract%20podcast%20microphone%20visualization%20with%20glowing%20sound%20waves%20on%20dark%20background%2C%20cyan%20and%20teal%20highlights%2C%20cybersecurity%20media%20aesthetic%2C%20no%20people&width=400&height=240&seq=res-img-007&orientation=landscape',
  },
  {
    id: 8,
    type: 'Certification Prep',
    title: 'CEH Exam Preparation',
    description: 'Complete study guide and practice exams for the Certified Ethical Hacker certification.',
    icon: 'ri-award-line',
    color: 'from-[#10B981] to-[#065F46]',
    count: '500+ questions',
    level: 'Advanced',
    image: 'https://readdy.ai/api/search-image?query=abstract%20certification%20badge%20and%20exam%20preparation%20visualization%20with%20glowing%20award%20ribbon%20on%20dark%20background%2C%20emerald%20green%20highlights%2C%20professional%20cybersecurity%20aesthetic%2C%20no%20people&width=400&height=240&seq=res-img-008&orientation=landscape',
  },
];
